module.exports = __webpack_public_path__ + "img/Instagram.62eb49cb.webp";